import React, { CSSProperties } from "react";
import DotLoader from "react-spinners/DotLoader";
import PropTypes from "prop-types";

const override: CSSProperties = {
  display: "block",
  margin: "0 auto",
  borderColor: "red"
};

export default function Spinner(props) {
  const {
    loading,
    size
    //...rest
  } = props;
  let sizeSpiner = 50;
  if (size) {
    sizeSpiner = size;
  }
  return (
    <div className="sweet-loading">
      <DotLoader
        cssOverride={override}
        size={sizeSpiner}
        color={"#042f41"}
        loading={loading}
      />
    </div>
  );
}

Spinner.propTypes = {
  loading: PropTypes.bool,
  size: PropTypes.number
};
